import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiUsers } from 'react-icons/fi';
import type { RoleKey } from '../types';

export const RoleBadges: React.FC<{ roles: RoleKey[] }> = ({ roles }) => {
  const { t } = useTranslation('HelpGuide');
  if (roles.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="mr-1 flex items-center gap-1 text-xs font-medium text-gray-500 dark:text-gray-400">
        <FiUsers size={12} />
        {t('audience.label')}
      </span>
      {roles.map((role) => (
        <span
          key={role}
          className="rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-xs text-gray-700 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
        >
          {t(`role.${role}`)}
        </span>
      ))}
    </div>
  );
};
